import { create } from 'zustand';

type ClaimIncentiveModalStoreProps = {
	isOpen: boolean;
	onClose: () => void;
	onOpen: ({ incentiveId, callback }: { incentiveId?: string; callback?: () => void }) => void;
	incentiveId?: string;
	callback?: () => void;
	lastClosedAt?: number;
};

const useClaimIncentiveModalStore = create<ClaimIncentiveModalStoreProps>((set, get) => ({
	isOpen: false,
	onClose: () => set({ isOpen: false, incentiveId: undefined, callback: undefined, lastClosedAt: Date.now() }),
	onOpen: ({ incentiveId, callback }: { incentiveId?: string; callback?: () => void }) => {
		const state = get();
		// prevent reopening immediately after close (within 500ms)
		// this is a bit of a hack, because multiple places use this
		// state manager and will attempt to reopen the modal as an
		// effect, so we want to block that just long enough that the
		// modal won't reopen on close/submit.
		if (state.lastClosedAt && Date.now() - state.lastClosedAt < 500) {
			return;
		}
		set({ isOpen: true, incentiveId, callback });
	},
	incentiveId: undefined,
	callback: undefined,
	lastClosedAt: undefined,
}));

export const useClaimIncentiveModal = () => useClaimIncentiveModalStore((state) => state);
